import React from 'react';
export const inactiveSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M0 1.25C0 0.5625 0.53125 0 1.21875 0H14.75C15.4375 0 16 0.5625 16 1.25C16 1.53125 15.875 1.8125 15.6875 2.03125L10 8.9375V12.9688C10 13.5312 9.5 14 8.9375 14C8.6875 14 8.46875 13.9375 8.28125 13.7812L6.375 12.3125C6.125 12.125 5.96875 11.8438 5.96875 11.5312V8.9375L0.28125 2.03125C0.09375 1.8125 0 1.53125 0 1.25ZM1.21875 1C1.09375 1 1 1.125 1 1.25C1 1.3125 1 1.34375 1.03125 1.40625L6.875 8.4375C6.9375 8.53125 7 8.65625 7 8.75V11.5312L8.90625 13C8.90625 13 8.90625 13 8.9375 13C8.96875 13 9 13 9 12.9688V8.75C9 8.65625 9.03125 8.53125 9.09375 8.4375L14.9375 1.40625C14.9688 1.34375 15 1.3125 15 1.25C15 1.125 14.875 1 14.75 1H1.21875Z"
      fill="currentColor"
    />
  </svg>
);

export const inactiveSVGString = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M0 1.25C0 0.5625 0.53125 0 1.21875 0H14.75C15.4375 0 16 0.5625 16 1.25C16 1.53125 15.875 1.8125 15.6875 2.03125L10 8.9375V12.9688C10 13.5312 9.5 14 8.9375 14C8.6875 14 8.46875 13.9375 8.28125 13.7812L6.375 12.3125C6.125 12.125 5.96875 11.8438 5.96875 11.5312V8.9375L0.28125 2.03125C0.09375 1.8125 0 1.53125 0 1.25ZM1.21875 1C1.09375 1 1 1.125 1 1.25C1 1.3125 1 1.34375 1.03125 1.40625L6.875 8.4375C6.9375 8.53125 7 8.65625 7 8.75V11.5312L8.90625 13C8.90625 13 8.90625 13 8.9375 13C8.96875 13 9 13 9 12.9688V8.75C9 8.65625 9.03125 8.53125 9.09375 8.4375L14.9375 1.40625C14.9688 1.34375 15 1.3125 15 1.25C15 1.125 14.875 1 14.75 1H1.21875Z"
      fill="currentColor"
    />
  </svg>`;
